import { ca } from '@cian/analytics';

export function trackClickIsAreaParts(isOfferEditing, product, siteType) {
  ca('eventSite', {
    name: 'oldevent',
    category: isOfferEditing ? 'Edit_ad' : 'New_ad',
    action: 'Click',
    label: 'rent_in_parts',
    page: {
      pageType: 'AddForm',
      siteType,
    },
    products: isOfferEditing ? [product] : [],
  });
}

export function trackFailAreaPart(isOfferEditing, product, siteType) {
  ca('eventSite', {
    name: 'oldevent',
    category: isOfferEditing ? 'Edit_ad' : 'New_ad',
    action: 'Fail',
    label: 'rent_in_parts_area',
    page: {
      pageType: 'AddForm',
      siteType,
    },
    products: isOfferEditing ? [product] : [],
  });
}
